// extracted by mini-css-extract-plugin
module.exports = {"container":"Register_container__3eMub"};